import { injectable } from "inversify";

import { UpdateEntityPayload, updateEntityWithProperties } from "@archipad-js/core/orm";

import { PersonEntity } from "@archipad-js/archipad-model";

@injectable()
export class PersonService {
    /**
     * Update the given person entity with the given properties.
     */
    public updatePerson(person: PersonEntity, payload: UpdateEntityPayload<PersonEntity>): void {
        updateEntityWithProperties(person, payload);
    }
}
